import { createTheme } from '@mui/material/styles';

export const COLORS = {
  navy: '#1B2A6B',
  pink: '#FF4D97',
  yellow: '#FFC83D',
  green: '#37B24D',
  blue: '#2D9CFF',
  orange: '#FF8A3D',
  purple: '#8B5CF6',
  red: '#F03E3E',
  cream: '#FFF8E7',
  sky: '#E6F6FF',
  text: '#3A3F5C',
};

export const FONTS = {
  heading: '"Baloo 2", "Trebuchet MS", sans-serif',
  body: '"Nunito", "Segoe UI", sans-serif',
};

const headingStyle = { fontFamily: FONTS.heading, fontWeight: 800 };

const theme = createTheme({
  shape: { borderRadius: 4 },
  palette: {
    primary: { main: COLORS.navy },
    secondary: { main: COLORS.pink },
    background: { default: '#ffffff' },
    text: { primary: COLORS.text },
  },
  typography: {
    fontFamily: FONTS.body,
    h1: headingStyle,
    h2: headingStyle,
    h3: headingStyle,
    h4: headingStyle,
    h5: headingStyle,
    h6: headingStyle,
    button: { fontFamily: FONTS.heading, fontWeight: 800, textTransform: 'none' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: { scrollBehavior: 'smooth' },
        body: { overflowX: 'hidden', backgroundColor: '#fff' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 50, textTransform: 'none', fontWeight: 800 },
      },
    },
  },
});

export default theme;
